<template>
    <el-drawer
        title="编辑观演人"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">
            <el-form
                v-if="itemData"
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
            >
                <el-form-item prop="name" label="观演人:" >
                    <el-input v-model="formDatas.name" placeholder="请输入观演人" size="medium" maxlength="40" show-word-limit ></el-input>
                </el-form-item>
                <el-form-item prop="documentType" label="证件类型">
                    <el-select v-model="formDatas.documentType" size="medium" placeholder="请选择证件类型" @change="formDatas.documentNumber = '';formDatas.placeIssue =''">
                        <el-option v-for="(item,index) in documentTypeList" :key="index" :value="item.value" :label="item.label"></el-option>
                    </el-select>
                </el-form-item>
				<el-form-item prop="placeIssue" label="护照签发地" v-if="formDatas.documentType == 4"  :rules="[{required: formDatas.documentType == 4  ? true : false, message: `请选择护照签发地`}]" >
				    <el-select v-model="formDatas.placeIssue" size="medium" placeholder="请选择护照签发地">
				        <el-option v-for="(item,index) in postcardList" :key="index" :value="item.name" :label="item.name"></el-option>
				    </el-select>
				</el-form-item>
                <el-form-item prop="documentNumber" label="证件号码:" >
                    <el-input v-model="formDatas.documentNumber" placeholder="请输入证件号码" size="medium" :maxlength="formDatas.documentType == 1 ? 18 : 20" ></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确定</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultFormData = {
    name:'',
    documentType:1,
    documentNumber:'',
	placeIssue:''
}
export default {
    props:{
        orderId:{
            type:String,
            default:''
        }
    },
    data(){
        const checkLength = (rule, value, callback) => {            
            const arr = [null, '身份证号填写错误', '港澳通行证', '台胞证', '护照'];
            let len = 18, msg = `${arr[this.formDatas.documentType]}`;
            if(this.formDatas.documentType != 1){
                len = 20;
                msg += `最多允许填写20个字符` 
            }
            if (value.length > len || this.formDatas.documentType == 1 && value.length != len) {
                callback(new Error(msg));
            } else {
                callback();
            }
        }
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas: {
                ...defaultFormData,
                orderId:this.orderId
            },
            rules:{
                name:[{required: true, message: '请选填写观演人'}],
                documentType:[{required: true, message: '请选择证件类型'}],
                documentNumber:[{required: true, message: '请输入证件号码'}, { validator: checkLength, trigger: 'blur' }],
            },
            itemData:null,
            sort:0,
            index:0,
			postcardList:[]
        }
    },
    computed:{
        documentTypeList(){
            return [{
                label:'身份证',
                value:1
            },{
                label:'港澳居民来往内地通行证',
                value:2
            },{
                label:'台湾居民来往大陆通行证',
                value:3
            },{
                label:'护照',
                value:4
            },{
                label:'外国人永久居留身份证',
                value:5
            },{
                label:'港澳台居民居住证',
                value:6
            }]
        }
    },
    methods:{
        close(){
            this.formDatas = { ...defaultFormData };
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
        },
        show(data,sort,index){
            this.itemData = {...data};
            this.formDatas = {
                ...defaultFormData,
                ...data
            }
			this.sort = sort;
			this.index = index;
			this.getPostcard();
            this.drawerShow = true;
        },
        //获取护照签发地国家
        getPostcard() {
        	this.$request({
        		url: "/common/allCountry",
        		method: "post",
        		
        	}).then(res => {
        		const { state, result } = res.data;
        		if (state == 1) {
        			this.postcardList = result || []
        		}
        	})
        },
        submitForm(){
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    // this.setOrderPerformers();
                    this.$request({
                        url: "/activiOrder/savePerformer",
                        method: "POST",
                        data: this.formDatas,
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                this.$emit('onUpdate', { data: { ...this.formDatas }, sort: this.sort, index: this.index });
                                this.close();
                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>